import { connect } from 'react-redux';

import { IState } from '../../store';
import { prefetchFormState } from '../../store/deal-rent';
import { SafeRentDescription } from './SafeRentDescription';
import { content, offlineContent } from './content';

export function mapStateToProps(state: IState) {
  const isDealRentOffline = Boolean(state.offerData.offer.isDealRentOffline);

  return {
    id: state.offerData.offer.id,
    content: isDealRentOffline ? offlineContent : content,
  };
}

export const SafeRentDescriptionContainer = connect(mapStateToProps, { openModal: prefetchFormState })(
  SafeRentDescription,
);
